/* ============================================
   Senchado 2.0 — Top Page (Home) behaviour
   出典: prototype/index-mockup-final.html <script>（確定版）
   仕様: docs/spec-top-page.md「状態判定の2層分離」「必須（Day X・Sprint H1）」
   defer 読込（各 home セクション liquid が先頭で stylesheet_tag、本JSは hero が defer 読込）。

   責務:
   (a) 状態切替の第2層 = signals（localStorage `senchado_signals` v1）
       { v:1, visits:[ts], viewed:[{handle,title,at}] }
       - viewed は handle 一意・最大20・エントリ単位 TTL 30日
       - viewed_count = TTL内ユニークhandle数（閾値 >=3）
       - return_visit = TTL内に6時間以上離れた visits が2セッション以上
       - 破損JSON / localStorage 不可（Safariプライベート等）は try/catch で黙って S0 デフォルト
   (b) S0 sub-variant 差し替え（return_visit > viewed_count>=3 > なし）。
       JS は Liquid の主variant（S0/S1/S4）を上書きしない。S0 のときだけ sub-variant を「重ねる」。
   (c) 実売ランキングのタブ切替（コンテンツは Liquid がサーバーレンダリング・JS は表示切替のみ）
   (d) チェックした商品（履歴）の localStorage 描画（空状態フォールバックあり）
   (e) 状態別の出し分けは 2026-08-03 に畳んだ（非ログイン/ログイン済みの2つだけ）。
       ?debug_state= / ?debug_signals= の切替口はどちらも使われていない
       （?debug_state= はそもそも効かない: request.query_string は Liquid に存在しない）

   注: viewed の「記録」は商品ページ側の責務（Phase 2 / 別タスク）。本JSは window.SenchadoSignals.recordView を
       公開するが、トップ自体は読み取り専用。
   ============================================ */

(function () {
  'use strict';

  var STORAGE_KEY = 'senchado_signals';
  var SCHEMA_VERSION = 1;
  var TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30日
  var SESSION_GAP_MS = 6 * 60 * 60 * 1000; // 6時間
  var VIEWED_MAX = 20;
  var VISITS_MAX = 100;

  // ---------------------------------------------
  // ユーティリティ
  // ---------------------------------------------
  function now() { return Date.now(); }

  function defaultSignals() {
    return { v: SCHEMA_VERSION, visits: [], viewed: [] };
  }

  function readSignals() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return defaultSignals();
      var d = JSON.parse(raw);
      if (!d || d.v !== SCHEMA_VERSION || !Array.isArray(d.visits) || !Array.isArray(d.viewed)) {
        // 非互換バージョン / 破損構造は破棄（移行コードは書かない・spec データモデル）
        return defaultSignals();
      }
      d.visits = pruneVisits(d.visits);
      d.viewed = pruneViewed(d.viewed);
      return d;
    } catch (e) {
      // 破損JSON / localStorage 不可 → 黙って S0 デフォルト。テーマJSを道連れにしない。
      return defaultSignals();
    }
  }

  function saveSignals(d) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(d));
    } catch (e) { /* 保存不可は黙殺 */ }
  }

  function pruneVisits(list) {
    var cut = now() - TTL_MS;
    var out = [];
    for (var i = 0; i < list.length; i++) {
      if (typeof list[i] === 'number' && list[i] >= cut) out.push(list[i]);
    }
    if (out.length > VISITS_MAX) out = out.slice(out.length - VISITS_MAX);
    return out;
  }

  function pruneViewed(list) {
    var cut = now() - TTL_MS;
    var out = [];
    for (var i = 0; i < list.length; i++) {
      var it = list[i];
      if (it && typeof it.handle === 'string' && typeof it.at === 'number' && it.at >= cut) {
        out.push({ handle: it.handle, title: typeof it.title === 'string' ? it.title : '', at: it.at });
      }
    }
    return out;
  }

  // viewed_count = TTL内ユニークhandle数
  function uniqueViewed(d) {
    var seen = {};
    var out = [];
    // 新しい順（at 降順）で一意化
    var sorted = d.viewed.slice().sort(function (a, b) { return b.at - a.at; });
    for (var i = 0; i < sorted.length; i++) {
      var h = sorted[i].handle;
      if (!seen[h]) { seen[h] = 1; out.push(sorted[i]); }
    }
    return out;
  }

  function viewedCount(d) { return uniqueViewed(d).length; }

  // return_visit = TTL内に6時間以上離れた visits が2セッション以上
  function isReturnVisit(d) {
    if (d.visits.length < 2) return false;
    var v = d.visits.slice().sort(function (a, b) { return a - b; });
    var sessions = 1;
    for (var i = 1; i < v.length; i++) {
      if (v[i] - v[i - 1] >= SESSION_GAP_MS) sessions++;
    }
    return sessions >= 2;
  }

  // 現在の訪問を記録（visits に push）
  function recordVisit(d) {
    d.visits = pruneVisits(d.visits);
    d.visits.push(now());
    if (d.visits.length > VISITS_MAX) d.visits = d.visits.slice(d.visits.length - VISITS_MAX);
    return d;
  }

  // 商品閲覧の記録（商品ページから呼ぶ想定・公開API）
  function recordView(handle, title) {
    if (!handle) return;
    var d = readSignals();
    var filtered = [];
    for (var i = 0; i < d.viewed.length; i++) {
      if (d.viewed[i].handle !== handle) filtered.push(d.viewed[i]);
    }
    filtered.push({ handle: String(handle), title: title ? String(title) : '', at: now() });
    // 新しい順に並べ、最大 VIEWED_MAX
    filtered.sort(function (a, b) { return b.at - a.at; });
    if (filtered.length > VIEWED_MAX) filtered = filtered.slice(0, VIEWED_MAX);
    d.viewed = filtered;
    saveSignals(d);
  }

  function getQueryParam(name) {
    try {
      var params = new URLSearchParams(window.location.search);
      return params.get(name);
    } catch (e) { return null; }
  }

  function esc(s) {
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function productUrl(handle) {
    var base = (window.routes && window.routes.root_url) ? window.routes.root_url : '';
    if (base === '/') base = '';
    return base + '/products/' + encodeURIComponent(handle);
  }

  // ---------------------------------------------
  // 履歴カードの画像解決（/products/{handle}.js）
  //   localStorage の viewed[] は {handle,title,at} しか持たないため、
  //   カード描画後に Ajax Product API で featured_image を取りに行く。
  //   取得失敗・画像なしは灰色プレースホルダのまま（穴を開けない）。
  //   404（削除・非公開）と BOX子はカードごと除去し、履歴からも落とす。
  //   ※価格はトップでは出さない（Ajax系JSON の price は ×100 という罠を踏まないため）。
  // ---------------------------------------------
  // Shopify CDN は width/height/crop で任意サイズを配信できる。カードは正方形
  // （CSS: aspect-ratio 1/1 + object-fit cover）なのでサーバ側で正方形クロップする。
  function sizedImg(url, width) {
    if (!url) return '';
    var sep = url.indexOf('?') >= 0 ? '&' : '?';
    return url + sep + 'width=' + width + '&height=' + width + '&crop=center';
  }
  function srcsetImg(url) {
    if (!url) return '';
    return [300, 450, 600, 900].map(function (w) {
      return sizedImg(url, w) + ' ' + w + 'w';
    }).join(', ');
  }

  function isBoxChild(p) {
    if (!p) return false;
    if (p.type === '定期便BOX子') return true;
    var tags = p.tags;
    if (Array.isArray(tags)) return tags.indexOf('_box_child') !== -1;
    return typeof tags === 'string' && tags.indexOf('_box_child') !== -1;
  }

  // handle → Promise（同一ページ内で return/viewed3/history が重複fetchしない）
  var productCache = {};
  function fetchProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch(productUrl(handle) + '.js')
        .then(function (res) {
          if (res.status === 404) return { gone: true };
          if (!res.ok) return null;
          return res.json();
        })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }

  // 履歴から handle を落とす（削除済み商品・BOX子の掃除）
  function dropViewed(handle) {
    var d = readSignals();
    var before = d.viewed.length;
    d.viewed = d.viewed.filter(function (x) { return x.handle !== handle; });
    if (d.viewed.length !== before) saveSignals(d);
    signals.viewed = signals.viewed.filter(function (x) { return x.handle !== handle; });
  }

  function applyCardImage(card, p) {
    var ph = card.querySelector('[data-sc-img]');
    if (!ph) return;
    var url = p.featured_image || (p.images && p.images[0]) || '';
    if (!url) return; // 画像なしは灰色のまま
    var img = document.createElement('img');
    img.className = ph.getAttribute('data-sc-img-class') || '';
    // sizes → srcset → src の順で設定（src 先行だと候補外の余計な読込が走りうる）
    img.sizes = ph.getAttribute('data-sc-img-sizes') || '200px';
    img.srcset = srcsetImg(url);
    img.src = sizedImg(url, 600);
    img.alt = '';
    img.loading = 'lazy';
    img.decoding = 'async';
    img.width = 600;
    img.height = 600;
    ph.replaceWith(img);
  }

  // container 内のカード画像を解決。全滅したら onEmpty()（スロットを閉じ直す）
  function resolveCardImages(container, onEmpty) {
    if (!container) return;
    var cards = Array.prototype.slice.call(container.querySelectorAll('[data-sc-handle]'));
    if (!cards.length) return;
    Promise.all(cards.map(function (card) {
      var handle = card.getAttribute('data-sc-handle');
      return fetchProduct(handle).then(function (p) {
        if (!container.isConnected || card.parentNode !== container) return;
        if (p && p.gone) { dropViewed(handle); card.remove(); return; }
        if (!p || !p.url) return; // 通信失敗は灰色のまま残す
        if (isBoxChild(p)) { dropViewed(handle); card.remove(); return; }
        applyCardImage(card, p);
      });
    })).then(function () {
      if (typeof onEmpty === 'function' && !container.querySelector('[data-sc-handle]')) onEmpty();
    });
  }

  // ---------------------------------------------
  // (c) ランキングのタブ切替
  // ---------------------------------------------
  function initRankingTabs(root) {
    var scopes = (root || document).querySelectorAll('[data-sc-rank]');
    scopes.forEach(function (scope) {
      if (scope.__scTabsBound) return;
      scope.__scTabsBound = true;
      var tabs = scope.querySelectorAll('[data-sc-rank-tab]');
      var panels = scope.querySelectorAll('[data-sc-rank-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.getAttribute('data-sc-rank-tab');
          tabs.forEach(function (t) {
            t.classList.toggle('is-active', t === tab);
            t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
          });
          panels.forEach(function (panel) {
            panel.hidden = panel.getAttribute('data-sc-rank-panel') !== key;
          });
        });
      });
    });
  }

  // ---------------------------------------------
  // (b) S0 sub-variant 差し替え
  // ---------------------------------------------
  function renderViewedCards(container, limit, variant) {
    if (!container) return 0;
    var items = uniqueViewed(signals).slice(0, limit);
    if (variant === 'history') {
      container.innerHTML = items.map(function (it) {
        return '<a class="history-item" href="' + productUrl(it.handle) + '" data-cv="home_history_' + esc(it.handle) + '" data-sc-handle="' + esc(it.handle) + '">' +
          '<div class="history-item__ph" data-sc-img data-sc-img-class="history-item__img" data-sc-img-sizes="140px">閲覧した商品</div>' +
          '<div class="history-item__name">' + (it.title ? esc(it.title) : esc(it.handle)) + '</div>' +
        '</a>';
      }).join('');
    } else {
      container.innerHTML = items.map(function (it) {
        return '<a class="hero__history-card" href="' + productUrl(it.handle) + '" data-cv="home_s0_' + esc(variant || 'sub') + '_' + esc(it.handle) + '" data-sc-handle="' + esc(it.handle) + '">' +
          '<div class="hero__history-img" data-sc-img data-sc-img-class="hero__history-img" data-sc-img-sizes="200px"></div>' +
          '<div class="hero__history-info">' +
            '<div class="hero__history-name">' + (it.title ? esc(it.title) : esc(it.handle)) + '</div>' +
          '</div>' +
        '</a>';
      }).join('');
    }
    return items.length;
  }

  /* 2026-08-03 谷本決裁: applySubVariant を削除した。
     未ログインの人の中でさらに出し分けていた2枚のスロット
     （「この前の、つづきから。」＝6時間以上あけて2回以上来た人 /
       「迷ったら、くらべてみる。」＝3商品以上見た人）は、出す条件が再現しづらく
     実機で確認されないまま公開寸前まで来ていたため、Liquid 側のスロットごと消した。
     谷本さん「確認してないやつは消したい」。
     signals の記録（recordVisit / recordView）と「チェックした商品」の履歴バンドは残す。
     出し分けを再開するなら docs/dayx-task-ssot.md C-48 の手順で。 */

  // ---------------------------------------------
  // (d) チェックした商品（履歴バンド）
  // ---------------------------------------------
  function renderHistory(root) {
    var section = (root || document).querySelector('[data-sc-history]');
    if (!section) return;
    var band = section.querySelector('[data-sc-history-band]');
    var empty = section.querySelector('[data-sc-history-empty]');
    if (!band) return;
    var n = renderViewedCards(band, VIEWED_MAX, 'history');
    if (empty) empty.hidden = n > 0;
    band.hidden = n === 0;
    resolveCardImages(band, function () {
      band.hidden = true;
      if (empty) empty.hidden = false;
    });
  }

  // ---------------------------------------------
  // スクロール出現アニメーション
  // ---------------------------------------------
  var revealObserver = null;
  function initReveal(root) {
    if (!('IntersectionObserver' in window)) {
      (root || document).querySelectorAll('.sc-home .reveal').forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
    }
    (root || document).querySelectorAll('.sc-home .reveal:not(.is-visible)').forEach(function (el) {
      revealObserver.observe(el);
    });
  }

  // ---------------------------------------------
  // 初期化（二重初期化ガード + bfcache 対応）
  // ---------------------------------------------
  var signals = defaultSignals();
  var booted = false;

  function boot() {
    signals = readSignals();
    signals = recordVisit(signals);
    saveSignals(signals);

    initRankingTabs(document);
    renderHistory(document);
    initReveal(document);
    booted = true;
  }

  function reboot() {
    // bfcache 復帰 / Theme Editor 再描画: signals を読み直して履歴を再評価
    signals = readSignals();
    renderHistory(document);
    initRankingTabs(document);
    initReveal(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { if (!booted) boot(); });
  } else {
    boot();
  }

  window.addEventListener('pageshow', function (e) {
    if (e.persisted && booted) reboot();
  });

  // Theme Editor（セクション再描画）対応
  document.addEventListener('shopify:section:load', function () { reboot(); });

  // 公開API（商品ページからの閲覧記録用・Phase 2）
  window.SenchadoSignals = {
    read: readSignals,
    recordView: recordView,
    viewedCount: function () { return viewedCount(readSignals()); },
    isReturnVisit: function () { return isReturnVisit(readSignals()); }
  };
})();
